let baseURL = "";
let analysisURL = "";
const { VUE_APP_ENV_VARIABLE } = process.env;
if (VUE_APP_ENV_VARIABLE == "development") {
  //本地环境
  baseURL = "/api";
  analysisURL = "http://yc2.yicheng1993.com";
} else if (VUE_APP_ENV_VARIABLE == "test") {
  // baseURL = "https://test.yicheng120.com:981";
  baseURL = "https://test-health.yicheng1993.com:881/YC_OTC_Health";
} else if (VUE_APP_ENV_VARIABLE == "production") {
  baseURL = "https://health.yicheng1993.com/YC_OTC_Health"; //正式线上环境
  analysisURL = "https://ai.yicheng1993.com"; //正式线上环境
  // baseURL = "http://yc.yicheng1993.com/YC_OTC_Health"; //测试环境
  // analysisURL = "http://yc2.yicheng1993.com"; //测试环境
}

export { baseURL, analysisURL };
